module.exports = __webpack_public_path__ + "img/03.a1cd0b9b.png";